'use client'

import { createContext } from 'react'

export interface FilterOptionsData {
  filterOptions: FilterGroup[],
}

export type OverviewPageFilters = {
  articleTypes: boolean;
  portfolioTypes: boolean;
  funds: boolean;
  strategies: boolean;
  years: boolean;
}

export type FilterOption = {
  value: string,
  displayName: string,
}

export type FilterGroup = {
  groupDisplayName?: string,
  groupName: string,
  filters: FilterOption[]
}

export const FilterOptionsContext = createContext<
  FilterOptionsData | undefined
>(undefined)
